export interface SubscriptionFull {
	name: string;
	numberOfEntitlementsUsed: number;
	numberOfEntitlements: number;
	channelLimit: number;
	expiry: string;
}

export interface SubscriptionsUsageStoreState {
	initialized: boolean;
	list: SubscriptionFull[];
	failed?: boolean;
}

export type PartialSubscriptionsUsageStoreState =
	Partial<SubscriptionsUsageStoreState>;

export interface GetSubscriptionsUsageResponse {
	subscriptions: SubscriptionFull[];
}

export interface AccountSubscriptionWithTransformations {
	accountSubscriptions: SubscriptionFull[];
	filteredSubscriptions: SubscriptionFull[];
	activeSubscriptions: SubscriptionFull[];
	expiredSubscriptions: SubscriptionFull[];
	initialized: boolean;
}
